import { render, staticRenderFns } from "./UtenteGeneralData.vue?vue&type=template&id=82a4b43c&"
import script from "./UtenteGeneralData.vue?vue&type=script&lang=ts&"
export * from "./UtenteGeneralData.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports